import { LocalStorageExpenseService } from './LocalStorageExpenseService';
import { FirebaseExpenseService } from './FirebaseExpenseService';

/**
 * Factory for creating expense storage service instances
 */
export class ExpenseStorageFactory {
  /**
   * Create a storage service based on storage mode
   * @param {string} storageMode - 'offline' or 'cloud'
   * @param {Object} [user] - Firebase user object (required for cloud mode)
   * @returns {import('./IExpenseStorageService').IExpenseStorageService}
   */
  static createService(storageMode, user = null) {
    if (storageMode === 'cloud' && user) {
      return new FirebaseExpenseService(user.uid);
    }

    // Default to localStorage for offline mode or when user is not available
    return new LocalStorageExpenseService();
  }
}
